// extracted by mini-css-extract-plugin
module.exports = {"video-js":"VideoPlayer_video-js__PQMq9"};